import type { NameI18n } from '@displaycms/contracts';

/**
 * Pick a localized display name for the current UI language, falling back to
 * French (the required primary field of NameI18n) when there is no English.
 * Shared by the composer + resource surfaces (previously duplicated per file).
 */
export function pickName(name: NameI18n, lang: 'fr' | 'en'): string {
  if (lang === 'en' && name.en && name.en.length > 0) return name.en;
  return name.fr;
}
